import React, { useState, useEffect, useRef } from "react";
import CanvasJSReact from "../../../../../../../lib/canvasjs/canvasjs.react";
import Loader from "../../../../../../settings/loader";
import commaNumber from "comma-number";
import "../style.scss";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

// Add custom color set for device platforms
CanvasJS.addColorSet("deviceColors", [
  "#0088FE", // Web - Blue
  "#FFBB28", // iOS - Yellow/Gold
  "#00C49F", // Android - Green
]);

function Slide2(props) {
  const [data, setData] = useState({
    pieData: [],
  });
  const [load, setLoad] = useState(0);
  const prevExport = useRef(props.export);

  useEffect(() => {
    if (props.data.state && !load) {
      const statistics = props.data.result.statistics;

      // Prepare pie chart data for CanvasJS
      const pieData = [
        {
          name: "Web",
          y: statistics.web || 0,
          platform: "web",
          color: "#0088FE",
        },
        {
          name: "iOS",
          y: statistics.ios || 0,
          platform: "ios",
          color: "#FFBB28",
        },
        {
          name: "Android",
          y: statistics.android || 0,
          platform: "android",
          color: "#00C49F",
        },
      ].filter((item) => item.y > 0);

      setData({
        pieData: pieData,
      });
      setLoad(1);
    }
  }, [props.data, load]);

  // Export logic - Similar to slide1.js
  useEffect(() => {
    if (
      prevExport.current !== props.export &&
      load === 1 &&
      data.pieData.length > 0
    ) {
      prevExport.current = props.export;

      // Calculate total logins and percentages
      const totalLogins = data.pieData.reduce((sum, item) => sum + item.y, 0);

      // Prepare export data
      const exportTableData = data.pieData.map((item) => {
        const percentage =
          totalLogins > 0 ? ((item.y / totalLogins) * 100).toFixed(1) : 0;
        return [item.name, commaNumber(item.y), `${percentage}%`];
      });

      // Add total row
      exportTableData.push(["Total", commaNumber(totalLogins), "100%"]);

      props.getData({
        type: "image",
        title: "Platform Distribution",
        subtitle: `Login statistics across ${data.pieData.length} platforms`,
        body: {
          table: [
            {
              title: "Platform Login Statistics",
              head: [["Platform", "Logins", "Percentage"]],
              body: exportTableData,
            },
          ],
          id: "exportPdf_Slide2",
        },
        // Additional metadata for enhanced exports
        summary: [
          {
            title: "Overview",
            data: [
              { label: "Total Logins", value: commaNumber(totalLogins) },
              { label: "Active Platforms", value: data.pieData.length },
              {
                label: "Most Used Platform",
                value:
                  data.pieData.reduce(
                    (max, item) => (item.y > max.y ? item : max),
                    data.pieData[0]
                  )?.name || "N/A",
              },
              {
                label: "Least Used Platform",
                value:
                  data.pieData.reduce(
                    (min, item) => (item.y < min.y ? item : min),
                    data.pieData[0]
                  )?.name || "N/A",
              },
            ],
          },
        ],
        chartData: {
          type: "pie",
          title: "Platform Distribution",
          data: data.pieData.map((item) => ({
            name: item.name,
            value: item.y,
            color: item.color,
            percentage:
              totalLogins > 0 ? ((item.y / totalLogins) * 100).toFixed(1) : 0,
          })),
        },
      });
    }
    // eslint-disable-next-line
  }, [props.export, load, data.pieData, props.getData]);

  // CanvasJS Pie Chart Options
  const pieChartOptions = {
    animationEnabled: true,
    colorSet: "deviceColors",
    title: {
      text: "",
    },
    data: [
      {
        type: "pie",
        startAngle: 75,
        toolTipContent: "<b>{name}</b>: {y} logins ({percentage}%)",
        showInLegend: true,
        legendText: "{name}",
        indexLabelFontSize: 14,
        indexLabel: "{name} - {percentage}%",
        dataPoints: data.pieData.map((item) => {
          const total = data.pieData.reduce((sum, d) => sum + d.y, 0);
          const percentage =
            total > 0 ? ((item.y / total) * 100).toFixed(1) : 0;
          return {
            y: item.y,
            name: item.name,
            color: item.color,
            percentage: percentage,
          };
        }),
      },
    ],
  };

  return (
    <div className="device-analytics-slide slide2" id="exportPdf_Slide2">
      {!load ? (
        <Loader />
      ) : (
        <div className="chart-container">
          <h2>Platform Distribution</h2>
          <div className="canvas-chart-wrapper" id="platformPieChart">
            {data.pieData.length > 0 ? (
              <CanvasJSChart options={pieChartOptions} />
            ) : (
              <div className="no-data-message">
                <p>No platform data available</p>
              </div>
            )}
          </div>

          {/* Summary Statistics for better context */}
          {/* <div className="platform-summary">
            <div className="summary-stats">
              <div className="stat-item">
                <span className="stat-label">Total Logins:</span>
                <span className="stat-value">
                  {commaNumber(
                    data.pieData.reduce((sum, item) => sum + item.y, 0)
                  )}
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Active Platforms:</span>
                <span className="stat-value">{data.pieData.length}</span>
              </div>
              {data.pieData.length > 0 && (
                <div className="stat-item">
                  <span className="stat-label">Most Used:</span>
                  <span className="stat-value">
                    {
                      data.pieData.reduce(
                        (max, item) => (item.y > max.y ? item : max),
                        data.pieData[0]
                      )?.name
                    }
                  </span>
                </div>
              )}
            </div> */}
          {/* </div> */}
        </div>
      )}
    </div>
  );
}

export default Slide2;
